<template>
  <div class="overview-company">
    <!-- <div class="title">
      <div class="big-title">腾景宏观经济感知预测全口径分析系统</div>
      <div>数字时代的新宏观经济分析体系</div>
    </div>-->
    <el-tabs v-model="activeName">
      <el-tab-pane label="钢铁行业预测预警系统" name="6">
        <p>
          <strong>腾景AI经济预测</strong>运用近年来快速发展的机器学习特别是深度学习等人工智能前沿技术，与实时化、动态化的投入产出体系深度融合，在一系列关键技术攻关的基础上，对重要的经济金融指标进行高频模拟和预测，形成了在国内外具有开拓性、领先性、实用性的产品体系。
        </p>
        <p>
          <strong>是什么</strong>
        </p>
        <p>
          <strong>钢铁行业预测预警系统</strong>是腾景AI经济预测在实体经济领域的具体应用。该系统运用特
          定人工智能算法和多种来源的丰富数据，对钢铁行业内的主要品种，上游的铁矿石、煤炭等主要投入品，下游的房地产、基建、能源、汽车、造船、机械等重要需求领域，进行了月度和周度水平的预测，为相关生产、流通、资本市场、行业管理部门等机构和人士在波动较大、不确定性强的市场环境中准确判断形势和科学决策提供有效支持。
          <strong>有些业内人士认为，这是一项以前未曾有过、令人耳目一新的预测性成果。</strong>
        </p>
        <p>
          <strong>为什么</strong>
        </p>

        <p>
          <strong>特点</strong>
        </p>
        <p>
          <strong>看得远：</strong>提前半年左右基本上把握住了重要指标的走势和大的拐点
        </p>
        <p>
          <strong>多维度：</strong>通过月度和周度分别进行预测，相互印证、相互补充
        </p>
        <p>
          <strong>全覆盖：</strong>预测范围既包括钢铁行业主要品种，也包括上下游主要行业
        </p>
        <p>
          <strong>提预警：</strong>当指标震荡频率和分布范围超出历史常规区间，将发出预警信号
        </p>
        <p>
          <strong>重实用：</strong>
          除了提供标准化数据库产品外，还可根据用户具体需求开发定制化产品，并运用预测结果提供切实管用的企业采购、生产和销售方案
        </p>
        <p>
          <strong>方向准：</strong>指标预测方向准确率通常达到70%以上
        </p>
        <p>
          <strong>数据库预览</strong>
        </p>
        <p>
          <strong>主屏区和点选区</strong>
        </p>
        <p>主展示区由主屏区和点选区组成，点击周围图标即可在主屏切换展示指标预测结果，也可通过主屏区右上角下拉菜单针对同一类别的指标在主屏区切换展示。</p>
        <p>钢铁行业预测预警系统包括上游行业、钢铁、和下游行业数据，在上方可以进行切换。</p>
        <p>上游行业包括煤炭和铁矿石的各项指标数据；钢铁包括主要钢材品种的数据；下游行业包括房地产、汽车、基建等7个重点下游行业数据及腾景钢材预警需求指数。</p>

        <p class="img">
          <img src="../../assets/img/14.png" alt />
        </p>
        <p>
          <strong>波动预警与数值预警</strong>
        </p>
        <p>波动预警与数值预警对于指标有提示功能：对于预测区间出现频繁波动或者数值有可能出现异常的指标会提供预警。</p>
        <p>指标预测结果有三种模式可以切换：预测模式仅作为预测区间段走势查看；分析模式可用鼠标滚轮控制查看历史区间信息，并附有文字描述；特征查询功能能最直观的看到深度学习挖掘出的相关性较强的领先指标。</p>
        <p class="img">
          <img src="../../assets/img/15.png" alt />
          <img src="../../assets/img/16.png" alt />
        </p>
        <p>
          <strong>对谁有用</strong>
        </p>
        <p>
          <strong>关心中国宏观和行业经济走势，尤其是钢铁行业和上游提供原材料、下行提供市场需求的企业和人士将会从中受益。</strong>重点包括
          <strong>
            钢铁行业本身和上下游关注采购、生产与销售的生产企业；
            对钢材和相关产品价格变化更为敏感、在整个钢铁供应链上担任重要角色的贸易商；
            关注行业增长预期，在现货与期货市场配置资源的金融机构或其它投资和资产管理部门等。
          </strong>
        </p>
        <p>
          <strong>钢铁行业预测预警系统是每一个钢铁和上下游企业实现高质量可持续发展必备的“专属产品”</strong>
        </p>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "6"
    };
  },
  created() {
    // if (this.$route.query.id) {
    //   this.activeName = this.$route.query.id;
    // }
  }
};
</script>

<style lang="scss" scoped>
.overview-company {
  background: #fff;
  margin: 20px 0 0 20px;
  padding: 20px;
  box-sizing: border-box;
  .title {
    color: #333399;
    text-align: center;
    font-size: 24px;
    padding: 30px 0;
    .big-title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }
  }
  p {
    text-indent: 32px;
    img {
      height: 300px;
      padding-bottom: 20px;
    }
    &.img {
      text-align: center;
    }
  }
  /deep/ .el-tabs .el-tabs__item {
    padding-left: 0 !important;
    padding-bottom: 14px !important;
    height: 42px !important;
    font-size: 16px !important;
  }
}
</style>